module.exports = "<label>{{caption}}</label>\r\n\r\n   <input type=\"date\"  [disabled]=\"disabled\" class=\"form-control ixsControl\" [(ngModel)]=\"value\" (blur)=\"onBlur()\">\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/date/date.component.html
// module id = 1041
// module chunks = 22